<template>
    <v-card class="rounded-0 mb-3" outlined>
        <!-- Cabeçalho Grande -->
        <v-card-title
            class="pa-0 ma-0 text-h6 grey lighten-4 d-flex"
            @click="toggleAberto"
            v-if="!mobile"
        >
            <v-icon class="text-h4 gray--text">{{ iconeExpandido }}</v-icon>
            <div class="flex-grow-1 text-h6">
                {{ limite(artigo.assunto, 300) }}
            </div>
            <div
                class="text-caption mr-2 d-flex flex-col flex-grow-0 align-end"
            >
                <v-icon
                    color="yellow"
                    dark
                    class="mr-2"
                    v-if="!artigo.visualizado"
                    >mdi-star</v-icon
                >
                <div class="mr-2" v-if="anexos.length > 0">
                    {{ anexos.length
                    }}<v-icon small dense class="">mdi-paperclip</v-icon>
                </div>
                <div>{{ formataData(artigo.criado) }}</div>
            </div>
            <v-icon class="text-h5 gray--text mx-2">{{ iconeDirecao }}</v-icon>
        </v-card-title>
        <!-- Cabeçalho Mobile -->
        <v-card-title
            class="pa-0 ma-0 text-subtile-2 grey lighten-4 d-flex flex-column"
            @click="toggleAberto"
            v-if="mobile"
        >
            <div
                class="d-flex flex-row justify-between align-self-stretch justify-start align-center pa-0 ma-0"
            >
                <v-icon class="text-h4 gray--text">{{ iconeExpandido }}</v-icon>
                <div class="">
                    {{ limite(artigo.assunto, 35) }}
                </div>
            </div>
            <div
                class="d-flex justify-end align-self-stretch text-caption mx-2"
            >
                <v-icon
                    color="yellow"
                    dark
                    class="mr-2"
                    v-if="!artigo.visualizado"
                    >mdi-star</v-icon
                >
                <div class="mr-2" v-if="anexos.length > 0">
                    {{ anexos.length
                    }}<v-icon small dense class="">mdi-paperclip</v-icon>
                </div>
                <div>{{ formataData(artigo.criado) }}</div>
            </div>
            <v-icon class="text-h5 gray--text mx-2">{{ iconeDirecao }}</v-icon>
        </v-card-title>
        <!-- Corpo -->
        <v-card-text v-if="aberto" class="pa-6 overflow-x-auto">
            <div
                v-html="artigoHtml"
                style="word-break: keep-all; white-space: pre-line"
            ></div>
        </v-card-text>
        <v-card-actions
            class="pa-6 grey lighten-4 d-flex flex-column align-start"
            v-if="mostrarAnexos"
        >
            <div v-for="anexo in anexos" :key="anexo.filename">
                <a
                    :download="anexo.filename"
                    :type="anexo.contenttype"
                    :href="createContent(anexo)"
                >
                    {{ anexo.filename }} ({{ anexo.filesize }})<v-icon
                        class="text-h4 gray--text mx-0"
                        >mdi-download-box</v-icon
                    >
                </a>
            </div>
        </v-card-actions>
    </v-card>
</template>

<script>
import utils from "../../utils/general"; // formataData, limite, etc....
import { mapActions, mapGetters } from "vuex";

const mapaDirecao = {
    entrada: "mdi-message-arrow-left-outline",
    saida: "mdi-message-arrow-right-outline",
};

export default {
    name: "detalhe-artigo",
    props: {
        artigo: {
            type: Object,
            required: true,
        },
        ticketId: {
            type: Number,
            required: true,
        },
        aberto: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            artigoHtml: "",
            anexos: [],
        };
    },
    computed: {
        iconeExpandido: function () {
            return this.aberto ? "mdi-menu-down" : "mdi-menu-right";
        },
        iconeDirecao: function () {
            return mapaDirecao[this.artigo.tipo];
        },
        mostrarAnexos() {
            return this.aberto && this.anexos.length > 0;
        },
        mobile: function () {
            return this.$vuetify.breakpoint.smAndDown;
        },
        ...mapGetters("contexto", ["contexto"]),
    },
    methods: {
        ...mapActions("visualizacoes", ["visualizarArtigo"]),
        createContent(anexo) {
            let content = anexo.content;
            // Emails chegam com MIME type + "base64" prefixados ao conteúdo pelo backend,
            // ex: "ion/octetstreambase64[base64 real]" em vez de apenas "[base64 real]".
            const base64Idx = content.indexOf("base64");
            if (base64Idx > 0 && base64Idx < 50) {
                content = content.substring(base64Idx + 6);
            }
            return "data:" + anexo.contenttype + ";base64," + content;
        },
        toggleAberto() {
            if (!this.aberto && !this.artigo.visualizado) {
                this.visualizarArtigo({
                    ticketId: this.ticketId,
                    articleId: this.artigo.id,
                    contextoId: this.contexto.id,
                });
                this.$emit("artigoVisualizado", this.artigo.id);
            }
            this.$emit("abrirFechar", {
                articleId: this.artigo.id,
                aberto: !this.aberto,
            });
        },
        ...utils,
    },
    mounted() {
        const inlineAnexo = this.artigo.anexos.find(
            (anexo) => anexo.disposition === "inline",
        );
        if (inlineAnexo) {
            const charsetMatch = inlineAnexo.contenttype?.match(
                /charset=([\w-]+)/i,
            );
            const charset = charsetMatch ? charsetMatch[1] : "utf-8";
            const bytes = Uint8Array.from(atob(inlineAnexo.content), (c) =>
                c.charCodeAt(0),
            );
            this.artigoHtml = new TextDecoder(charset).decode(bytes);
        }
        this.anexos = this.artigo.anexos.filter(
            (anexo) => anexo.disposition !== "inline",
        );
    },
};
</script>
